/**
 * Story 053 — TanStack Query keys for the admin user-management feature.
 *
 * Per `tanstack-query-conventions` skill — narrow, hierarchical keys
 * so invalidations target the smallest slice that matters.
 */
import type {
  ListAuditParams,
  ListInvitationsParams,
  ListUsersParams,
} from "./types.js";

export const adminKeys = {
  all: ["admin"] as const,

  users: () => [...adminKeys.all, "users"] as const,
  usersList: (params: ListUsersParams) =>
    [...adminKeys.users(), "list", params] as const,
  user: (id: string) => [...adminKeys.users(), "detail", id] as const,

  invitations: () => [...adminKeys.all, "invitations"] as const,
  invitationsList: (params: ListInvitationsParams) =>
    [...adminKeys.invitations(), "list", params] as const,

  audit: () => [...adminKeys.all, "audit"] as const,
  auditList: (params: ListAuditParams) =>
    [...adminKeys.audit(), "list", params] as const,
};
